export const isValidPassword = (password: string) => {
  const regex = /(?=.{8,})(?=.*[0-9])(?=.*[a-z])/i;
  return regex.test(String(password));
};
